<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
    </auto-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "enroll_name"},
        { name: "职位", value: "team_position" },
        { name: "分成比例", value: "commission_rate" },
        { name: "加入时间", value: "join_at" },
      ],
      Total: 0,
      status: 1,
      load: false,
      manager: JSON.parse( localStorage.getItem("managerInfo")),
    };
  },

  mounted() {
    this.id = this.$route.query.id;
  },

  methods: {
    confirm(row) {
      this.$confirm("确认学员已经到店体验，确认后将结算佣金给招生人。").then(
        () => {
          this.$post("/user/enrollDemands/confArr", {
            id: row.id,
            verified_by: this.manager.id,
          }).then((res) => {
            this.getList(1);
          });
        }
      );
    },

    openGeo(row) {
      this.$refs.amap.open(row);
    },
    init() {
      if (!this.load) {
        this.load = true;
        this.getList(1);
      }
    },
    openAdd() {
      let comm = { venue_id: this.id };
      this.$refs.add.open(comm);
    },
    openEdit(row) {
      this.$refs.add.open(row);
    },

    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/enrollTeamMembers/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          team_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>